import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'invite-prompt.invite-error-flag.title',
		defaultMessage: 'Something went wrong',
		description: 'Title shown in the invite error notification flag.',
	},
	description: {
		id: 'invite-prompt.invite-error-flag.description',
		defaultMessage: 'Try inviting your teammates again. If the problem persists, contact support.',
		description: 'Description informing the user that invites were not successfully sent',
	},
	action: {
		id: 'invite-prompt.invite-error-flag.action',
		defaultMessage: 'Contact support',
		description: 'Action button label to contact support for invite errors.',
	},
});
